const errorToNameAndMessage = (errorLike: unknown): { name: string; message: string } => {
  if (errorLike instanceof Error) {
    return { name: errorLike.name ?? "", message: errorLike.message ?? "" };
  }
  if (typeof errorLike === "string") {
    return { name: "", message: errorLike };
  }
  if (errorLike && typeof errorLike === "object") {
    const maybeName = "name" in errorLike ? String((errorLike as { name?: unknown }).name ?? "") : "";
    const maybeMessage = "message" in errorLike ? String((errorLike as { message?: unknown }).message ?? "") : "";
    return { name: maybeName, message: maybeMessage };
  }
  return { name: "", message: "" };
};

// デプロイ後にブラウザが古いバンドルをキャッシュし続けることで発生するエラーかどうかを判定する。
// この関数はそういったデプロイ起因のロードエラーを検出し、自動リロードやSentry への分類タグ付けに使用する。
// ネイティブ dynamic import の失敗メッセージはブラウザごとに異なる
// （Chrome / Edge: "Failed to fetch dynamically imported module" / Firefox: "error loading dynamically imported module"）ため、
// 共通する "dynamically imported module" という語順のまとまりで両方を吸収する。
// 過検知すると無関係なエラーで自動リロードが走り本来のエラーを握り潰すため、"module" 単独では判定しない。
// 同じ目的の実装が propally_admin/src/utils/logics/assetUpdateMismatch.ts にもある。条件を直すときは両方揃えること。
export const isDeployBundleMismatchError = (errorLike: unknown): boolean => {
  const { name, message } = errorToNameAndMessage(errorLike);
  const text = `${name}\n${message}`.toLowerCase();

  return (
    text.includes("chunkloaderror") ||
    text.includes("loading chunk") ||
    text.includes("css chunk load failed") ||
    text.includes("dynamically imported module") ||
    text.includes("importing a module script failed") ||
    (text.includes("unexpected token") && text.includes("<")) ||
    (text.includes("failed to fetch") && text.includes("module")) ||
    // 古いバンドルのAPIクライアントがデプロイ後に新しいレスポンス構造を受け取り statusCode を参照できなくなるケース
    (text.includes("cannot read properties of undefined") && text.includes("statuscode")) ||
    // Service Worker やネットワーク層がデプロイ後に古いリクエストを中断するケース
    text.includes("request has been terminated")
  );
};
